import React from "react";
import { Box } from "@mui/material";
import { PanelModel } from "survey-core";
import { ReactElementFactory, SurveyPanel } from "survey-react-ui";
import { COLORS } from "components/v3/Theme/colors";

interface ScrollablePanelProps {
  element: PanelModel;
}

/** CMS legal forms use `panel-intro`; kit consent may use `panel-intro-*` for multiple docs. */
export const isScrollableAgreementPanel = (name?: string): boolean =>
  name === "panel-intro" || Boolean(name?.startsWith("panel-intro-"));

const ScrollablePanel: React.FC<ScrollablePanelProps> = (props) => (
  <Box
    className="terms-scrollable-panel"
    sx={{
      border: `1px solid ${COLORS.GRAY}`,
      borderRadius: "8px",
      backgroundColor: COLORS.WHITE,
      maxHeight: { xs: "70vh", md: "55vh" },
      height: "auto",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      minHeight: 0,
      my: 1,
      // SurveyJS nests the panel and paints its own frame — keep only our border.
      "& .sd-element--nested-with-borders": {
        border: "none",
        borderRadius: 0,
        paddingRight: 0
      }
    }}
  >
    <Box
      className="terms-scrollable-panel__content"
      sx={{
        flexGrow: 1,
        overflowY: "auto",
        maxHeight: { xs: "70vh", md: "55vh" },
        minHeight: 0,
        width: "98%",
        px: 1
      }}
    >
      <SurveyPanel {...props} />
    </Box>
  </Box>
);

ReactElementFactory.Instance.registerElement("panel", (props: any) => {
  if (props.element && isScrollableAgreementPanel(props.element.name)) {
    return <ScrollablePanel {...props} />;
  }
  return React.createElement(SurveyPanel, props);
});

export default ScrollablePanel;
